import script from "./GloablHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./GloablHeader.vue?vue&type=script&setup=true&lang=ts"

import "./GloablHeader.vue?vue&type=style&index=0&id=1310fb2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1310fb2e"]])

export default __exports__